"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptableLogger = void 0;
const debugFactory = require('debug');
function humanize(ms) {
    return `${ms}ms`;
}
debugFactory.humanize = humanize;
const performanceTime = (previousTime) => {
    const now = performance.now();
    return previousTime ? now - previousTime : now;
};
class AdaptableLogger {
    // use static loggers whenever access to AdaptableLogger instance is not feasible
    static consoleErrorBase(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.error(message, optionalParams);
        }
        else {
            console.error(message);
        }
    }
    static consoleWarnBase(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.warn(message, optionalParams);
        }
        else {
            console.warn(message);
        }
    }
    static consoleLogBase(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.log(message, optionalParams);
        }
        else {
            console.log(message);
        }
    }
    constructor(adaptableId) {
        this.adaptableId = adaptableId;
        this.debugger = debugFactory(`Adaptable:${adaptableId}`);
        this.infoLogger = this.debugger.extend(`info`);
        this.infoLogger.log = console.info.bind(console);
        this.successLogger = this.debugger.extend(`success`);
        this.successLogger.log = console.log.bind(console);
        this.warnLogger = this.debugger.extend(`warn`);
        this.warnLogger.log = console.warn.bind(console);
        this.errorLogger = this.debugger.extend(`error`);
        this.errorLogger.log = console.error.bind(console);
        this.perfLogger = this.debugger.extend(`perf`);
        this.perfLogger.log = console.debug.bind(console);
    }
    beginPerf(sectionName) {
        this.perfLogger(`[BEGIN] - ${sectionName}`);
        const startTime = performanceTime();
        return {
            end: (additionalComment) => {
                this.perfLogger(`[END]   - ${sectionName} ${additionalComment ? `(${additionalComment})` : ''} :: [delta +${performanceTime(startTime)}ms]`);
            },
        };
    }
    info(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            this.infoLogger(message, ...optionalParams);
        }
        else {
            this.infoLogger(message);
        }
    }
    success(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            this.successLogger(message, ...optionalParams);
        }
        else {
            this.successLogger(message);
        }
    }
    warn(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            this.warnLogger(message, ...optionalParams);
        }
        else {
            this.warnLogger(message);
        }
    }
    error(message, ...optionalParams) {
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            this.errorLogger(message, ...optionalParams);
        }
        else {
            this.errorLogger(message);
        }
    }
    consoleLogByMessageType(message, messageType, ...optionalParams) {
        message = `AdapTable:${this.adaptableId} ${messageType}: ${message}`;
        switch (messageType) {
            case 'Info':
                console.info(message, optionalParams);
                break;
            case 'Success':
                console.log(message, optionalParams);
                break;
            case 'Warning':
                console.warn(message, optionalParams);
                break;
            case 'Error':
                console.error(message, optionalParams);
                break;
        }
    }
    consoleInfo(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.info(message, optionalParams);
        }
        else {
            console.info(message);
        }
    }
    consoleLog(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.log(message, optionalParams);
        }
        else {
            console.log(message);
        }
    }
    consoleWarn(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.warn(message, optionalParams);
        }
        else {
            console.warn(message);
        }
    }
    consoleError(message, ...optionalParams) {
        message = `AdapTable:${this.adaptableId}: ${message}`;
        if (optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.length) {
            console.error(message, optionalParams);
        }
        else {
            console.error(message);
        }
    }
}
exports.AdaptableLogger = AdaptableLogger;
